import { LoadableAfterPaint } from '@confluence/loadable';

export const SourcesList = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSourcesList" */ '../src/components/SourcesList.tsx'
			)
		).SourcesList,
});
